/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import { getCartTotal, mergeDeep, isTrue } from '@root/utility'

import { handleChange } from '@/Form/Functions/eventsHandling'
import getFormStatus    from '@/Form/Functions/getFormStatus'

import FormElement from '@/Form/toolkit/FormElement'

import bemit from '@function/bemit'

const { app, numeral } = window;

numeral.locale('en');

export default class Payment extends Component
{
	state =
	{
		form_data: { },
		status_messages: { },
		EC: { },
		permissions: { title: 'not_logged_in' }
	};

	componentDidMount ()
	{
		const component = this;

		component.setState(
		{
			form_data: _.cloneDeep(app.state.order_process['payment'])
		});

		app.push(
		{
			event: 'serverOrderProcessUpdate',
			cb: component.handleProcessFetched
		});

		app.push(
		{
			event: 'order_processChange',
			cb: component.handleProcessChange
		});

		app.push(
		{
			event: 'orderProcessErrorsUpdate',
			cb: component.handleErrorsUpdate
		});

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		if (app.state.session?.id)
		{
			component.handleSessionChange('componentWillMount');
		}

		if (app.state.order_process?.fetched)
		{
			component.handleProcessFetched();
		}
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'serverOrderProcessUpdate',
			cb: component.handleProcessFetched
		});

		app.delete(
		{
			event: 'orderProcessErrorsUpdate',
			cb: component.handleErrorsUpdate
		});

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleProcessChange = ({ source, ...params }) =>
	{
		const component = this, props = this.props, state = this.state;

		if (source === 'Payment') return;

		component.handleProcessFetched();
	}

	handleErrorsUpdate = () =>
	{
		const component = this, props = this.props, state = this.state;

		const errors = (app.state.order_process.errors || { }).payment;

		let status_messages = Object.assign({ }, (errors.status_messages || { }));

		component.setState(
		{
			error: (errors || { }).error,
			status_messages: status_messages
		});
	}

	handleProcessFetched = () =>
	{
		const component = this;

		const form_data = mergeDeep({ }, app.state.order_process['payment']);

		let cart_total = getCartTotal();

		if (cart_total.total === 0)
		{
			if (form_data['payment[method]'] !== 'free')
			{
				form_data['payment[method]'] = 'free';

				app.state.order_process.payment['payment[method]'] = 'free';

				app.emit('order_processChange', { source: 'Payment' });
			}
		}
		else
		{
			if (form_data['payment[method]'] === 'free')
			{
				form_data['payment[method]'] = '';
			}

			if (app.state.order_process.payment['payment[method]'] === 'free')
			{
				app.state.order_process.payment['payment[method]'] = '';

				app.emit('order_processChange', { source: 'Payment' });
			}
		}

		component.setState(
		{
			form_data: form_data
		});
	}

	handleSessionChange = (source) =>
	{
		const component = this, props = this.props;

		component.setState(
		{
			EC: _.cloneDeep(app.state.session.EC),
			permissions: _.cloneDeep(app.state.session.permissions)
		});
	}

	handleChange = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

		handleChange.bind(component)(e, data);

		app.state.order_process['payment'] = _.cloneDeep(state.form_data);

		if (!e)
		{
			let store_value = app.state.order_process['shipping'][data.name];

			if (typeof store_value !== 'undefined' && store_value !== data.value)
			{
				return;
			}
			else if (typeof store_value === 'undefined' && data.value === '')
			{
				return;
			}
		}

		if (e)
		{
			app.emit('order_processChange', { source: 'Payment' });
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let payment_methods =
		[
			{
				title: 'Carte Bancaire',
				value: 'CC',
				info: 'Vous serez redirigé vers une page de paiement sécurisée.'
			},
			{
				title: 'Chèque',
				value: 'check',
				info: 'À l\'ordre de SYNERGIES.'
			},
			{
				title: 'Virement',
				value: 'bank_transfert',
				info: 'Notre IBAN vous sera communiqué par e-mail.'
			}
		];

		let payment_config = _.cloneDeep(state.EC.config || { });

		if (Object.keys(payment_config.override || { }).length &&
			state.permissions.title !== 'EC')
		{
			Object.keys(payment_config)
			.filter(field => !isTrue(payment_config.override[field]))
			.forEach(function (field)
			{
				payment_config[field] = payment_config.override[field];
			});
		}

		if (state.form_data['payment[method]'] === 'free')
		{
			payment_methods =
			[
				{
					title: 'Offert',
					value: 'free',
					info: 'Offert'
				}
			];

			payment_config =
			{
				payment_free: true
			};
		}

		let infos_text = undefined;

		payment_methods = payment_methods.filter(function (method)
		{
			return isTrue(payment_config['payment_' + method.value]);
		})
		.map(function (method, key)
		{
			if (state.form_data['payment[method]'] === method.value)
			{
				infos_text = method.info;
			}

			let output =
			(
				<div className="c-order-process__payment-method" key={ method.value }>

					<FormElement className="c-form-element c-form-element--inline"
						name="payment[method]" type="radio" data={ state.form_data }
						label={ method.title } status={ state.status_messages }
						onChange={ component.handleChange }
						radio_value={ method.value }
					/>

				</div>
			);

			return output;
		});

		var output =
		(
			<div className="c-order-process__step">

				<h2 className="c-order-process__title">
					<span className="c-order-process__title-number">3</span>
					Mode de paiement
				</h2>

				{ getFormStatus(state) }

				<div className="c-order-process__payment-methods">
					{ payment_methods }
				</div>

				{
					infos_text ?
					(
						<div className={ bemit('c-message',
							['v2', 'green', 'condensed']) + ' u-margin-bottom-0' }>
							{ infos_text }
						</div>
					)
					: undefined
				}

			</div>
		);

		return output;
	}
}